/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';

import { withStyles } from '@material-ui/core/styles'

import { Paper, Typography, CircularProgress, IconButton, Tooltip } from '@material-ui/core'
import { Refresh } from '@material-ui/icons'

import Actions from '../../../../fluid/Actions/ActionFactory'
import signals from '../../DataGenerator/Signals';

import ErrorMessage from '../../../Common/ErrorMessage';

class KeyMetric extends Component {
    state = {
        loading : false,
        value : null,
        value_error : null
    }

    componentWillMount () {
        if (this.props.value === null) {
            let signal_params = {}
            let signal_config = signals.find(signal => signal.type === this.props.signal_type)
            console.log("Chart Signal Config: ", signal_config)
            signal_config.parameters.map(param => {
                signal_params[param.name] = param.default_value
            })

            this.setState({
                ...this.state,
                value : null,
                signal_params : signal_params
            }, () => {
                if (this.props.filter !== null) {
                    this.getData()
                }
            })
        }
    }

    componentDidUpdate (prevProps) {
        if (JSON.stringify(prevProps.filter) !== JSON.stringify(this.props.filter)) {
            this.getData()
        }
    }

    getData = () => {
        let total_value = 0
        this.setState({
            ...this.state,
            loading : true
        }, () => {
            Actions('http_request', {
                url : this.props.drl_url + "/analytics/cube",
                method : "post",
                data : {
                    signal : this.props.signal_type,
                    start_date : this.props.filter.start_date,
                    end_date : this.props.filter.end_date,
                    resolution : this.props.filter.resolution,
                    entity_list : [],
                    mode : 0,
                    signal_params : this.state.signal_params
                }
            }).then(res => {
                res.data.data.map(el => {
                    total_value = total_value + el.value
                })

                this.setState({...this.state, value: total_value ,loading : false})
            }).catch(err => {
                this.setState({
                    ...this.state,
                    value : null,
                    value_error : err,
                    loading: false
                })
            })
        })
    }

    getValue = () => {
        if (this.props.value !== null) {
            return (
                <Typography style = {{fontWeight : 600}} variant = 'h5' color = 'primary'>{this.props.value}</Typography>
            )
        } else {
            if (this.props.filter !== null) {
                if (this.state.value === null) {
                    if (this.state.value_error !== null) {
                        return (
                            <ErrorMessage error_message = "Error Retreiving Data" err = {this.state.value_error}/>
                        )
                    }
                } else {
                    return (
                        <Typography style = {{fontWeight : 600}} variant = 'h5' color = 'primary'>{this.state.value}</Typography>
                    )
                }
            } else {
                return (
                    <Typography variant = 'caption' color = 'textSecondary'>Select a Time Interval</Typography>
                )
            }
        }
    }

    render() {
        return (
            <Paper square elevation = {2} variant = 'outlined' style = {{width : '100%', height : '100px', display : 'flex', flexDirection : 'column'}}>
                <div style = {{width : '100%', borderBottom : '1px solid rgba(0,0,0,0.12)', padding : '5px', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                    <div style = {{flexGrow : 1}}>
                        <Typography variant = 'subtitle2'>{this.props.label}</Typography>
                    </div>
                    <Tooltip title = "Refresh">
                        <IconButton size = 'small' color = {this.state.loading ? 'primary' : ''} onClick = {() => {
                            if (this.props.value === null) {
                                this.getData()
                            }
                        }}>
                            <Refresh fontSize = 'small'/>
                        </IconButton>
                    </Tooltip>
                </div>
                <div style = {{width : '100%', flexGrow : 1, display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                    {this.state.loading ? <CircularProgress size = {20}/> : this.getValue()}
                </div>  
            </Paper>
        );
    }
}

export default KeyMetric;